var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"w-6 h-6",class:_vm.corIcone,staticStyle:{"width":"24px","height":"24px"},attrs:{"fill":"currentColor","stroke-width":"2","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.pathIcon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }